/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationResponseBaseResponse as ModelsV3ApplicationApplicationResponseBaseResponse } from '../../models/Models/v3/Application/application-response-base-response';
import { ApplicationStartBrokerRequest as ModelsV3ApplicationApplicationStartBrokerRequest } from '../../models/Models/v3/Application/application-start-broker-request';

export interface V3ApplicationVehicleBrokerPost$Xml$Json$Params {
      body?: ModelsV3ApplicationApplicationStartBrokerRequest
}

export function v3ApplicationVehicleBrokerPost$Xml$Json(http: HttpClient, rootUrl: string, params?: V3ApplicationVehicleBrokerPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationVehicleBrokerPost$Xml$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>;
    })
  );
}

v3ApplicationVehicleBrokerPost$Xml$Json.PATH = '/v3/application/vehicle/broker';
